/* ==========================================================================
   LAST PALLET - reveal on scroll

   Fades in any element with class="reveal" as it enters the viewport
   (product cards, step blocks, etc). Used site-wide.

   This used to live inside scroll-world.js, which only loads on pages with
   the scroll-world hero animation - the homepage, essentially. Every other
   page (the collection grid, product pages, About, the blog) has .reveal
   elements too, but never loaded the script that removes their initial
   opacity: 0. They rendered correctly, with real data, real images, real
   prices - just permanently invisible, because nothing ever added the
   .is-in class that reveals them. Splitting this into its own file that
   every page loads fixes it for good, rather than papering over one page
   at a time.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__lpReveal) { return; }
  window.__lpReveal = true;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function boot() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) { return; }

    if (!('IntersectionObserver' in window) || prefersReducedMotion()) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
